import React from 'react';
import { Box } from '@mui/material';

const MainHeaderButtonsWrapper = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      {children}
    </Box>
  );
};

export default MainHeaderButtonsWrapper;